export default __webpack_public_path__ + "static/media/arrowdown-white.d0f2a219.svg";